import React from 'react';

import './Profile.scss';
import icons from '../../shared/assets/icons';
import { getString } from '../../helpers/styles';

const {
  Chat,
  Globe,
  Twitter,
  Settings,
  Facebook,
  Location,
  Subscribe,
  Instagram
} = icons;

export default function Profile(props) {
  const {
    bio,
    uri,
    posts,
    address,
    website,
    twitter,
    followed,
    facebook,
    following,
    instagram,
    displayName,
    isSubscribed,
    organization,
    profilePicture
  } = props.profile;

  const isChannel = props.type === 'channel';

  return (
    <section id="profile">
      <div id="profile_header">
        <img src={profilePicture} alt="profile-image" />

        <div>
          <p>{posts}</p>
          <span>{isChannel ? 'Posts' : 'Reacties'}</span>
        </div>

        <div>
          <p>{followed}</p>
          <span>Volgers</span>
        </div>

        {!isChannel && (
          <div>
            <p>{following}</p>
            <span>Volgend</span>
          </div>
        )}
      </div>

      <h1 id="profile_name">{displayName}</h1>

      <div id="profile_button_box" className="profile_desktop">
        {buttons()}
      </div>

      <p id="profile_bio" dangerouslySetInnerHTML={{ __html: bio }} />

      <ul id="profile_social_media">
        {website && (
          <li>
            <a href={website} target="_blank" rel="noopener noreferrer">
              <Globe />
              {website}
            </a>
          </li>
        )}

        {facebook && (
          <li>
            <a href={facebook} target="_blank" rel="noopener noreferrer">
              <Facebook />
              {facebook}
            </a>
          </li>
        )}

        {twitter && (
          <li>
            <a href={twitter} target="_blank" rel="noopener noreferrer">
              <Twitter />
              {twitter}
            </a>
          </li>
        )}

        {instagram && (
          <li>
            <a href={instagram} target="_blank" rel="noopener noreferrer">
              <Instagram />
              {instagram}
            </a>
          </li>
        )}

        {address && (
          <li>
            <Location />
            {address}
          </li>
        )}
      </ul>

      <div id="profile_button_box" className="profile_mobile">
        {buttons()}
      </div>
    </section>
  );

  function buttons() {
    return (
      <React.Fragment>
        <button
          onClick={() => handle()}
          className={getString(
            'profile_button_subscribed',
            isChannel && isSubscribed
          )}
        >
          {isChannel ? (
            <span>
              <Subscribe />

              {isSubscribed ? 'Geabonneerd' : 'Abonneer'}
            </span>
          ) : (
            <span>
              <Settings />
              Profiel instellingen
            </span>
          )}
        </button>

        {props.user &&
          props.user.username &&
          isChannel &&
          organization &&
          organization.chatFeature && (
            <React.Fragment>
              <br />
              <a href={`/create-room/${organization.accountName}`}>
                <button id="profile_chat_button">
                  <span>
                    <Chat />
                    Open chat
                  </span>
                </button>
              </a>
            </React.Fragment>
          )}
      </React.Fragment>
    );
  }

  function handle() {
    if (!isChannel) return (location.href = 'profile-settings');

    if (isSubscribed) unsubscribe();
    else subscribe();
  }

  function subscribe() {
    if (!props.user || !props.user.username)
      return props.showLoginPopup('Log in om een kanaal te volgen');

    props.subscribeChannel({
      variables: {
        channelUri: uri
      }
    });
  }

  function unsubscribe() {
    props.unsubscribeChannel({
      variables: {
        channelUri: uri
      }
    });
  }
}
